module.exports = __webpack_public_path__ + "static/media/circle-light.44f20f81.png";